export function formatCompact(value: number, fractionDigits = 1): string {
  const abs = Math.abs(value);
  if (abs >= 1_000_000) return `${(value / 1_000_000).toFixed(fractionDigits)}M`;
  if (abs >= 1_000) return `${(value / 1_000).toFixed(fractionDigits)}k`;
  return value.toLocaleString("en-GB");
}
